// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .selected {\n  background: rgba(var(--vs-primary), 0.1) !important;\n}\n.mother-indicator {\n  width: 160px;\n}\n[dir=ltr] .mother-indicator {\n  margin-left: 50%;\n  left: 80px;\n}\n[dir=rtl] .mother-indicator {\n  margin-right: 50%;\n  right: 80px;\n}\n.tag {\n  font-weight: bold;\n}\n[dir] .tag {\n  background-color: var(--gray) !important;\n  border-radius: 5px;\n  margin: 2px;\n  padding: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
